import { detectPlatform } from "../utils/platformDetection";

export const trackEvent = (event: string, properties = {}) => {
  if (window.analytics) {
    const platform = detectPlatform();
    window.analytics.track(event, {
      ...properties,
      platform,
    });
  } else {
    console.warn("Segment not loaded yet");
  }
};

export const identifyUser = (userId: string, traits = {}) => {
  if (window.analytics) {
    const platform = detectPlatform();
    window.analytics.identify(userId, {
      ...traits,
      platform,
    });
  } else {
    console.warn("Segment not loaded yet");
  }
};

export const pageView = () => {
  if (window.analytics) {
    const platform = detectPlatform();
    window.analytics.page({
      platform,
    });
  } else {
    console.warn("Segment not loaded yet");
  }
};
